import { css } from 'lit';
import { fsDesignToken } from '../../../core/style-util.js';

export const style = css`
  .step-income__add-additional-source {
    display: block;
    font-weight: ${fsDesignToken('fsFontWeightSemibold')};
    margin-bottom: 1em;
    text-align: center;
    text-decoration: none;
  }
`;
